
/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'doorman': {
    width: 16,
    height: 16,
    viewBox: '0 0 12 20',
    data: '<path pid="0" d="M3.016 10q0 .247-.014.544A1.365 1.365 0 0 0 4.2 12 2.215 2.215 0 0 0 3 14c0 1.29 1.311 4.967 3.085 4.967S9 15.2 9 14a2.379 2.379 0 0 0-1.145-2Q9 11.223 9 10.544V10h1a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-6a2 2 0 0 1 2-2zm-.991-6h7.951q.024.246.024.5A4.272 4.272 0 0 1 6 9a4.272 4.272 0 0 1-4-4.5q0-.253.024-.5zm-.934-.958Q0 2.519 0 2t1.09-.992A8.88 8.88 0 0 1 4.373 0h3.243a9.34 9.34 0 0 1 3.285 1.006q1.11.5 1.1.992t-1.144.992zm4.927 14.92q-1.983-2.77-1.983-3.689a3.794 3.794 0 0 1 1.3-2.289q-1.3-.331-1.3-.994c0-.662.759-.991 1.993-.991s1.973.343 1.973.991q0 .647-1.315.994A5.075 5.075 0 0 1 8 14.378q0 .722-1.983 3.584z" _fill="#d9d9d9" fill-rule="evenodd"/>'
  }
})
